import { defineComponent, computed } from '@vue/composition-api';
import i18n from './k18n';
export default defineComponent({
  components: {},
  props: {
    inviterName: {
      type: String,
      required: true
    },
    referralOfficerFans: {
      type: String,
      required: true
    },
    currencySymbol: {
      type: String,
      required: true
    },
    estimatedAward: {
      type: String,
      required: true
    }
  },
  setup: function setup(props) {
    var desc = computed(function () {
      var text = i18n.t('creator_scout_invitee_top_desc1');
      var inner0HTML = "<span\n            class=\"other-color\"\n                    >".concat(props.inviterName, "</span>");
      text = text.replaceAll('{0}', inner0HTML);
      return text;
    });
    var desc2 = computed(function () {
      var text = i18n.t('creator_scout_invitee_top_desc2');
      var innerX1HTML = "<span\n            class=\"other-color\"\n                    >".concat(props.referralOfficerFans, "</span>");
      var innerAHTML = "<span\n            class=\"other-color\"\n                    >".concat(props.currencySymbol, "</span>");
      var inner0HTML = "<span\n            class=\"other-color\"\n                    >".concat(props.estimatedAward, "</span>");
      text = text.replaceAll('{0}', inner0HTML).replaceAll('{X1}', innerX1HTML).replaceAll('{A}', innerAHTML);
      return text;
    });
    return {
      desc2: desc2,
      desc: desc
    };
  }
});